// extracted by mini-css-extract-plugin
export default {"clickable":"J6KGih"};